// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-common_medium {
  width: 520px;
}
.dl-dialog-common_warning {
  padding: 28px 32px;
}
.dl-dialog-common_warning .g-dialog-btn-close__btn {
  margin-top: 10px;
}
.dl-dialog-common_warning:not(.dl-dialog-common_medium) {
  width: 444px;
}
.dl-dialog-common__body-container {
  width: 292px;
  padding: 16px 12px;
}
.dl-dialog-common__body-container_warning {
  padding: 16px 0;
  width: auto;
}
.dl-dialog-common__body {
  display: flex;
  align-items: center;
}
.dl-dialog-common__header_warning {
  padding: 0 0 15px;
}
.dl-dialog-common__message {
  padding: 0 12px;
  line-height: 26px;
}
.dl-dialog-common__message_no-icon {
  padding: 0;
}
.dl-dialog-common__message_warning {
  line-height: 1.3;
}
.dl-dialog-common__footer {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.dl-dialog-common__footer_warning {
  justify-content: flex-end;
}
.dl-dialog-common__icon_warning {
  margin-right: 5px;
  color: var(--g-color-text-warning);
}
.dl-dialog-common__button {
  display: flex;
  align-items: center;
  flex: 0 0 50%;
  padding: 0 2px 4px;
}
.dl-dialog-common__button_warning {
  flex: 0;
  margin-left: 10px;
}
.dl-dialog-common__button_first {
  padding-left: 4px;
}
.dl-dialog-common__button_last {
  padding-right: 4px;
}
.dl-dialog-common__button_first.dl-dialog-common__button_last:not(.dl-dialog-common__button_warning) {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogCommon/DialogCommon.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR;AAGI;EACI,kBAAA;AADR;AAGQ;EACI,gBAAA;AADZ;AAKI;EACI,YAAA;AAHR;AAMI;EACI,YAAA;EACA,kBAAA;AAJR;AAOI;EACI,eAAA;EACA,WAAA;AALR;AAQI;EACI,aAAA;EACA,mBAAA;AANR;AAUQ;EACI,iBAAA;AARZ;AAYI;EACI,eAAA;EACA,iBAAA;AAVR;AAaI;EACI,UAAA;AAXR;AAcI;EACI,gBAAA;AAZR;AAeI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAbR;AAgBI;EACI,yBAAA;AAdR;AAiBI;EACI,iBAAA;EACA,kCAAA;AAfR;AAkBI;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAhBR;AAmBI;EACI,OAAA;EACA,iBAAA;AAjBR;AAoBI;EACI,iBAAA;AAlBR;AAqBI;EACI,kBAAA;AAnBR;AAsBI;EACI,OAAA;AApBR","sourcesContent":[".dl-dialog-common_medium {\n  width: 520px;\n}\n.dl-dialog-common_warning {\n  padding: 28px 32px;\n}\n.dl-dialog-common_warning .g-dialog-btn-close__btn {\n  margin-top: 10px;\n}\n.dl-dialog-common_warning:not(.dl-dialog-common_medium) {\n  width: 444px;\n}\n.dl-dialog-common__body-container {\n  width: 292px;\n  padding: 16px 12px;\n}\n.dl-dialog-common__body-container_warning {\n  padding: 16px 0;\n  width: auto;\n}\n.dl-dialog-common__body {\n  display: flex;\n  align-items: center;\n}\n.dl-dialog-common__header_warning {\n  padding: 0 0 15px;\n}\n.dl-dialog-common__message {\n  padding: 0 12px;\n  line-height: 26px;\n}\n.dl-dialog-common__message_no-icon {\n  padding: 0;\n}\n.dl-dialog-common__message_warning {\n  line-height: 1.3;\n}\n.dl-dialog-common__footer {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n}\n.dl-dialog-common__footer_warning {\n  justify-content: flex-end;\n}\n.dl-dialog-common__icon_warning {\n  margin-right: 5px;\n  color: var(--g-color-text-warning);\n}\n.dl-dialog-common__button {\n  display: flex;\n  align-items: center;\n  flex: 0 0 50%;\n  padding: 0 2px 4px;\n}\n.dl-dialog-common__button_warning {\n  flex: 0;\n  margin-left: 10px;\n}\n.dl-dialog-common__button_first {\n  padding-left: 4px;\n}\n.dl-dialog-common__button_last {\n  padding-right: 4px;\n}\n.dl-dialog-common__button_first.dl-dialog-common__button_last:not(.dl-dialog-common__button_warning) {\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
